/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React, { useCallback } from 'react';
import { AIGeneralBlockCard } from '../../AIGeneralBlockCard';
import { Table, TableSize } from '../../../molecules/Table/Table';
import { mapColumns, exportToCsv } from './utils';
import './DataTableRendererStyles.scss';
export function DataTableRenderer({ block }) {
    const tableBlock = block;
    const uiColumns = mapColumns(tableBlock.columns);
    const handleExport = useCallback(() => {
        exportToCsv(tableBlock);
    }, [tableBlock]);
    // export_options is missing/undefined/null for legacy producers — treat that
    // as "csv allowed" (deploy-skew safe). Once present, it is the source of
    // truth: a scalar-aggregate table sends export_options: [] and must not
    // offer a client-side CSV export of rows it never had (IP-15660 — QA
    // exported a one-cell "Inspection Count / 2625" table next to the real
    // 3,162-row server export). A multi-row table keeps its own export even
    // when the same turn also renders a file_download block — that CSV is the
    // aggregate of every table in the turn, not a substitute for exporting one
    // dataset on its own.
    const canExportCsv = tableBlock.export_options == null || tableBlock.export_options.includes('csv');
    return (React.createElement(AIGeneralBlockCard, { footerGroups: canExportCsv
            ? [
                {
                    actions: [
                        { id: 'export-csv', label: 'Export CSV', icon: 'fa-light fa-download', onClick: handleExport }
                    ]
                }
            ]
            : [] },
        React.createElement(Table, { columns: uiColumns, data: tableBlock.rows, size: TableSize.Auto, sortable: true, paginated: true, pageSize: 10, getItemId: (row) => {
                // Prefer row.id if available
                if (row && typeof row === 'object' && 'id' in row && row.id) {
                    return String(row.id);
                }
                // Fallback: create a deterministic hash from row content, disambiguated by
                // position — identical-content rows would otherwise hash to the same id
                // and collide as React keys / selection ids.
                const rowStr = JSON.stringify(row);
                let hash = 0;
                for (let i = 0; i < rowStr.length; i += 1) {
                    const char = rowStr.charCodeAt(i);
                    hash = (hash * 31 + char) | 0;
                }
                return `row-${Math.abs(hash)}-${tableBlock.rows.indexOf(row)}`;
            } })));
}
